import React, { useState, useEffect, useCallback } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Card,
  Button,
  Table,
  Pagination,
  Badge,
} from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Breadcrumb } from "react-bootstrap";
import {
  createLeaveType,
  getAllLeaveTypes,
  updateLeaveType,
} from "../../../../api/onboarddeboard";

const LeaveType = () => {
  const token = localStorage.getItem("token");

  const [leaveName, setLeaveName] = useState("");
  const [leaveCode, setLeaveCode] = useState("");
  const [color, setColor] = useState("#6366f1");
  const [yearly, setYearly] = useState(false);
  const [forService, setForService] = useState(false);
  const [docRequired, setDocRequired] = useState(false);
  const [paidLeave, setPaidLeave] = useState(false);
  const [compLeave, setCompLeave] = useState(false);
  const [active, setActive] = useState(true);

  const [leaveTypes, setLeaveTypes] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [errors, setErrors] = useState({});
  const [isEditing, setIsEditing] = useState(false);
  const [editId, setEditId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("ALL");
  const [sortField, setSortField] = useState("name");

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchTerm);
    }, 400);
    return () => clearTimeout(timer);
  }, [searchTerm]);

  const fetchLeaveTypes = useCallback(async () => {
    setIsLoading(true);
    try {
      const res = await getAllLeaveTypes(token);
      setLeaveTypes(res.data || []);
    } catch {
      toast.error("Error loading leave types.");
    } finally {
      setIsLoading(false);
    }
  }, [token]);

  useEffect(() => {
    if (token) fetchLeaveTypes();
  }, [token, fetchLeaveTypes]);

  useEffect(() => {
    let filtered = [...leaveTypes];

    if (debouncedSearch.trim()) {
      filtered = filtered.filter(
        (item) =>
          item.leaveName
            .toLowerCase()
            .includes(debouncedSearch.toLowerCase()) ||
          item.leaveCode?.toLowerCase().includes(debouncedSearch.toLowerCase()),
      );
    }

    if (statusFilter !== "ALL") {
      const isActive = statusFilter === "ACTIVE";
      filtered = filtered.filter((item) => item.status === isActive);
    }

    if (sortField === "name") {
      filtered.sort((a, b) => a.leaveName.localeCompare(b.leaveName));
    } else if (sortField === "status") {
      filtered.sort((a, b) => {
        if (a.status === b.status)
          return a.leaveName.localeCompare(b.leaveName);
        return a.status ? -1 : 1;
      });
    }

    setFilteredData(filtered);
    setCurrentPage(1);
  }, [leaveTypes, debouncedSearch, statusFilter, sortField]);

  const handleLeaveName = (e) => {
  const value = e.target.value;
  setLeaveName(value);

  const trimmedValue = value.trim();

  if (/^\s+$/.test(value)) {
    setErrors((prev) => ({
      ...prev,
      leaveName: "Leave Name cannot be only spaces.",
    }));
    return;
  }

  if (/^\d+$/.test(trimmedValue)) {
    setErrors((prev) => ({
      ...prev,
      leaveName: "Leave Name cannot be only numeric.",
    }));
    return;
  }

  if (/^[^a-zA-Z0-9]+$/.test(trimmedValue)) {
    setErrors((prev) => ({
      ...prev,
      leaveName: "Leave Name cannot be only special characters.",
    }));
    return;
  }

  if (
    /^[^a-zA-Z]*$/.test(trimmedValue) &&
    /[0-9]/.test(trimmedValue) &&
    /[^a-zA-Z0-9]/.test(trimmedValue)
  ) {
    setErrors((prev) => ({
      ...prev,
      leaveName:
        "Leave Name cannot be only numbers and special characters.",
    }));
    return;
  }

  if (trimmedValue.length > 100) {
    setErrors((prev) => ({
      ...prev,
      leaveName: "Leave Name cannot exceed 100 characters.",
    }));
    return;
  }

  const duplicate = leaveTypes.some(
    (leave) =>
      leave.leaveName.toLowerCase() === trimmedValue.toLowerCase() &&
      (!isEditing || leave.id !== editId)
  );

  if (duplicate) {
    setErrors((prev) => ({
      ...prev,
      leaveName: "A Leave Name with this name already exists.",
    }));
    return;
  }

  
  setErrors((prev) => ({
    ...prev,
    leaveName: "",
  }));
};

  const handleLeaveCode = (e) => {
    const value = e.target.value;
    setLeaveCode(value);

    if (!value) {
      setErrors((prev) => ({
        ...prev,
        leaveCode: "",
      }));
      return;
    }

    if (/^\s+$/.test(value)) {
      setErrors((prev) => ({
        ...prev,
        leaveCode: "Leave Code cannot contain spaces only.",
      }));
      return;
    }
    if (value.length > 0 && /^[^a-zA-Z0-9]+$/.test(value)) {
      setErrors((prev) => ({
        ...prev,
        leaveCode: "Leave Code cannot contain special characters only.",
      }));
      return;
    }
    if (value.length > 10) {
      setErrors((prev) => ({
        ...prev,
        leaveCode: "Leave Code cannot exceed 10 characters.",
      }));
      return;
    }
    
     const duplicateCode = leaveTypes.some(
    (leave) =>
      leave.leaveCode?.trim().toLowerCase() ===
        value.trim().toLowerCase() &&
      (!isEditing || leave.id !== editId)
  );

  if (duplicateCode) {
    setErrors((prev) => ({
      ...prev,
      leaveCode: "A Leave Code with this code already exists.",
    }));
    return;
  }


    setErrors((prev) => ({ ...prev, leaveCode: "" }));
  };

  const handleSubmit = async () => {
    if (isSubmitting) return;

    let formValid = true;
    const newErrors = {};

   if (/^\s+$/.test(leaveName)) {
      newErrors.leaveName = "Leave Name cannot be only spaces.";
      formValid = false;
    } else if (!leaveName.trim()) {
      newErrors.leaveName = "Leave Name is required.";
      formValid = false;
    } else if (/^\d+$/.test(leaveName.trim())) {
      newErrors.leaveName = "Leave Name cannot be only numeric.";
      formValid = false;
    } else if (/^[^a-zA-Z0-9]+$/.test(leaveName.trim())) {
      newErrors.leaveName = "Leave Name cannot be only special characters.";
      formValid = false;
    } else if (
      /^[^a-zA-Z]*$/.test(leaveName.trim()) &&
      /[0-9]/.test(leaveName.trim()) &&
      /[^a-zA-Z0-9]/.test(leaveName.trim())
    ) {
      newErrors.leaveName =
        "Leave Name cannot be only numbers and special characters.";
      formValid = false;
    } else if (leaveName.length > 100) {
      newErrors.leaveName = "Leave Name cannot exceed 100 characters.";
      formValid = false;
    }

    const duplicate = leaveTypes.find(
  (l) =>
    l.leaveName.toLowerCase() === leaveName.trim().toLowerCase() &&
    (!isEditing || l.id !== editId)
);

if (duplicate) {
  newErrors.leaveName = "A Leave Name with this name already exists.";
  formValid = false;
}

    if (leaveCode.trim()) {
      const duplicateCode = leaveTypes.find(
        (l) =>
          l.leaveCode?.trim().toLowerCase() ===
            leaveCode.trim().toLowerCase() && l.id !== editId,
      );

      if (duplicateCode) {
        newErrors.leaveCode = "A Leave Code with this code already exists.";
        formValid = false;
      }
    }

    if (leaveCode.length > 0) {
      if (/^\s+$/.test(leaveCode)) {
        newErrors.leaveCode = "Leave Code cannot contain spaces only.";
        formValid = false;
      } else if (/^[^a-zA-Z0-9]+$/.test(leaveCode)) {
        newErrors.leaveCode =
          "Leave Code cannot contain special characters only.";
        formValid = false;
      } else if (leaveCode.length > 10) {
        newErrors.leaveCode = "Leave Code cannot exceed 10 characters.";
        formValid = false;
      }
    }

    if (yearly && forService) {
      toast.error("A leave type cannot be both Yearly and For Service — please choose only one.");
      formValid = false;
    }

    setErrors(newErrors);
    if (!formValid) return;

    const payload = {
      leaveName: leaveName.trim(),
      leaveCode,
      color,
      yearly,
      forService,
      documentCompulsory: docRequired,
      paidLeave: paidLeave,
      compensatoryLeave: compLeave,
      status: active,
    };

    setIsSubmitting(true);
    try {
      if (isEditing) {
        await updateLeaveType(editId, payload, token);
        toast.success("LeaveType Updated successfully");
      } else {
        await createLeaveType(payload, token);
        toast.success("LeaveType Created successfully");
      }
      resetForm();
      fetchLeaveTypes();
    } catch {
      toast.error("Error occurred");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleEdit = (item) => {
    setErrors({});
    setLeaveName(item.leaveName || "");
    setLeaveCode(item.leaveCode || "");
    setColor(item.color || "#6366f1");
    setYearly(item.yearly ?? false);
    setForService(item.forService ?? false);
    setDocRequired(item.documentCompulsory ?? false);
    setPaidLeave(item.paidLeave ?? false);
    setCompLeave(item.compensatoryLeave ?? false);
    setActive(item.status ?? true);
    setEditId(item.id);
    setIsEditing(true);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const resetForm = () => {
    setLeaveName("");
    setLeaveCode("");
    setColor("#6366f1");
    setYearly(false);
    setForService(false);
    setDocRequired(false);
    setPaidLeave(false);
    setCompLeave(false);
    setActive(true);
    setIsEditing(false);
    setEditId(null);
    setErrors({});
  };

  const paginated = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const handleExportCSV = () => {
    const headers = [
      "Leave Name",
      "Leave Code",
      "Yearly",
      "For Service",
      "Paid Leave",
      "Status",
    ];
    const rows = filteredData.map((item) => [
      item.leaveName,
      item.leaveCode || "",
      item.yearly ? "Yes" : "No",
      item.forService ? "Yes" : "No",
      item.paidLeave ? "Yes" : "No",
      item.status ? "Active" : "Inactive",
    ]);

    let csv = headers.join(",") + "\n";
    rows.forEach((row) => {
      csv += row.map((cell) => `"${cell}"`).join(",") + "\n";
    });

    const blob = new Blob([csv], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `leave-types-${new Date().toISOString().split("T")[0]}.csv`;
    a.click();
    window.URL.revokeObjectURL(url);
  };

  return (
    <Container fluid className="p-3 p-md-6">
        <style>{`
            .leave-toggle .form-check-input:checked {
                background-color: #2E5CB8 !important;
                border-color: #2E5CB8 !important;
            }
            .leave-toggle .form-check-input:focus {
                border-color: #2E5CB8 !important;
                box-shadow: 0 0 0 0.1rem rgba(46, 92, 184, 0.35) !important;
            }
            .lc-breadcrumb a {
                text-decoration: none !important;
                color: #2E5CB8 !important;
            }
            .lc-breadcrumb .breadcrumb-item.active {
                color: #6c757d !important;
            }
            .pagination .page-item.active .page-link {
                background-color: #2E5CB8 !important;
                border-color: #2E5CB8 !important;
            }
            @media (max-width: 575.98px) {
                .leavetype-search-controls .form-control,
                .leavetype-search-controls .form-select {
                    width: 100% !important;
                }
            }
        `}</style>
 <h1 className="page-main-heading" style={{ marginBottom: 12 }}>
            Leave Type
        </h1>
      <Breadcrumb className="lc-breadcrumb">
        <Breadcrumb.Item href="#">Leave</Breadcrumb.Item>
        <Breadcrumb.Item href="#">Master</Breadcrumb.Item>
        <Breadcrumb.Item active>Leave Type</Breadcrumb.Item>
      </Breadcrumb>

      {/* ── Form Card ── */}
      <Row className="mb-4">
        <Col xl={12}>
          <Card>
            <Card.Body>
              <Form>
                <Row>
                  <Col xs={12} md={6}>
                    <Row className="mb-3">
                      <Form.Label className="col-12 col-sm-3 col-form-label form-label">
                        Leave Name<span className="text-danger">*</span>
                      </Form.Label>
                      <Col xs={12} sm={9}>
                        <Form.Control
                          type="text"
                          placeholder="Enter Leave Name"
                          value={leaveName}
                          onChange={handleLeaveName}
                        />
                        {errors.leaveName && (
                          <p
                            style={{
                              color: "red",
                              fontSize: "13px",
                              marginTop: "3px",
                            }}
                          >
                            {errors.leaveName}
                          </p>
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Form.Label className="col-12 col-sm-3 col-form-label form-label">
                        Leave Code
                      </Form.Label>
                      <Col xs={12} sm={9}>
                        <Form.Control
                          type="text"
                          placeholder="Enter Leave Code"
                          value={leaveCode}
                          onChange={handleLeaveCode}
                        />
                        {errors.leaveCode && (
                          <p
                            style={{
                              color: "red",
                              fontSize: "13px",
                              marginTop: "3px",
                            }}
                          >
                            {errors.leaveCode}
                          </p>
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Form.Label className="col-12 col-sm-3 col-form-label form-label">
                        Color
                      </Form.Label>
                      <Col xs={12} sm={9}>
                        <div className="d-flex align-items-center gap-2 flex-wrap">
                          <Form.Control
                            type="color"
                            value={color}
                            onChange={(e) => setColor(e.target.value)}
                            style={{ width: "60px", height: "40px" }}
                          />
                          <Form.Control
                            type="text"
                            value={color}
                            onChange={(e) => {
                              const value = e.target.value;
                              if (/^#[0-9A-Fa-f]{0,6}$/.test(value))
                                setColor(value);
                            }}
                            placeholder="#000000"
                            style={{ minWidth: "120px", flex: "1 1 120px" }}
                          />
                        </div>
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Form.Label className="col-12 col-sm-3 col-form-label form-label">
                        Active
                      </Form.Label>
                      <Col xs={12} sm={9} className="mt-2 mt-sm-2">
                        <div className="leave-toggle">
                          <Form.Check
                            type="switch"
                            id="active"
                            label="Check If Active"
                            checked={active}
                            onChange={(e) => setActive(e.target.checked)}
                           />
                        </div>
                      </Col>
                    </Row>
                  </Col>

                  <Col xs={12} md={6}>
                    <Row className="mb-2">
                      <Form.Label className="col-12 col-sm-5 col-form-label form-label">
                        Yearly
                      </Form.Label>
                      <Col xs={12} sm={7} className="mt-2 mt-sm-2">
                        <div className="leave-toggle">
                            <Form.Check
                                type="switch"
                                id="yearly"
                                label="Check If Yearly"
                                checked={yearly}
                                onChange={(e) => {
                                    const checked = e.target.checked;
                                    setYearly(checked);
                                    if (checked) setForService(false);
                                }}
                            />
                        </div>
                      </Col>
                    </Row>

                    <Row className="mb-2">
                      <Form.Label className="col-12 col-sm-5 col-form-label form-label">
                        For Service
                      </Form.Label>
                      <Col xs={12} sm={7} className="mt-2 mt-sm-2">
                        <div className="leave-toggle">
                            <Form.Check
                                type="switch"
                                id="forService"
                                label="For Service"
                                checked={forService}
                                onChange={(e) => {
                                    const checked = e.target.checked;
                                    setForService(checked);
                                    if (checked) setYearly(false);
                                }}
                            />
                        </div>
                      </Col>
                    </Row>

                    <Row className="mb-2">
                      <Form.Label className="col-12 col-sm-5 col-form-label form-label">
                        Document Compulsory
                      </Form.Label>
                      <Col xs={12} sm={7} className="mt-2 mt-sm-2">
                        <div className="leave-toggle">
                          <Form.Check
                            type="switch"
                            id="docRequired"
                            label="Document Required"
                            checked={docRequired}
                            onChange={(e) => setDocRequired(e.target.checked)}
                          />
                        </div>
                      </Col>
                    </Row>

                    <Row className="mb-2">
                      <Form.Label className="col-12 col-sm-5 col-form-label form-label">
                        Paid Leave
                      </Form.Label>
                      <Col xs={12} sm={7} className="mt-2 mt-sm-2">
                        <div className="leave-toggle">
                          <Form.Check
                            type="switch"
                            id="paidLeave"
                            label="Paid Leave"
                            checked={paidLeave}
                            onChange={(e) => setPaidLeave(e.target.checked)}
                          />
                        </div>
                      </Col>
                    </Row>

                    <Row className="mb-2">
                      <Form.Label className="col-12 col-sm-5 col-form-label form-label">
                        Compensatory Leave
                      </Form.Label>
                      <Col xs={12} sm={7} className="mt-2 mt-sm-2">
                        <div className="leave-toggle">
                            <Form.Check
                                type="switch"
                                id="compLeave"
                                label="Compensatory Leave"
                                checked={compLeave}
                                onChange={(e) => setCompLeave(e.target.checked)}
                            />
                        </div>
                      </Col>
                    </Row>
                  </Col>

                  <Row className="align-items-center">
                    <Col xs={12} className="mt-4 d-flex align-items-center justify-content-center flex-wrap gap-2">
                      <Button
                        variant="primary"
                        type="button"
                        onClick={handleSubmit}
                        disabled={isSubmitting}
                        style={{ backgroundColor: "#2E5CB8", borderColor: "#2E5CB8" }}
                      >
                        {isSubmitting
                          ? isEditing ? "Updating..." : "Submitting..."
                          : isEditing ? "Update" : "Submit"}
                      </Button>
                      <Button
                        variant="secondary"
                        style={{ marginLeft: "10px" }}
                        onClick={resetForm}
                      >
                        Cancel
                      </Button>
                    </Col>
                  </Row>
                </Row>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* ── List Card ── */}
      <Row>
        <Col xl={12}>
          <Card>
            <Card.Header className="d-flex justify-content-between align-items-center flex-wrap gap-2">
              <h5 className="mb-0">Leave Types List</h5>
              <Button
                variant="outline-primary"
                size="sm"
                onClick={handleExportCSV}
                style={{ color: "#2E5CB8", borderColor: "#2E5CB8" }}
              >
                <i className="bi bi-download me-2"></i>Export CSV
              </Button>
            </Card.Header>

            <Card.Body>
              <Row className="mb-3 justify-content-end align-items-center leavetype-search-controls g-2">
                <Col xs={12} sm="auto">
                  <Form.Control
                    type="text"
                    placeholder="Search..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{
                      width: "260px",
                      maxWidth: "100%",
                      fontSize: "14px",
                      height: "32px",
                      padding: "4px 10px",
                    }}
                  />
                </Col>
                <Col xs={6} sm="auto">
                  <Form.Select
                    value={statusFilter}
                    onChange={(e) => setStatusFilter(e.target.value)}
                    style={{
                      width: "130px",
                      maxWidth: "100%",
                      fontSize: "14px",
                      height: "32px",
                      padding: "4px 10px",
                    }}
                  >
                    <option value="ALL">All Status</option>
                    <option value="ACTIVE">Active</option>
                    <option value="INACTIVE">Inactive</option>
                  </Form.Select>
                </Col>
                <Col xs={6} sm="auto">
                  <Form.Select
                    value={sortField}
                    onChange={(e) => setSortField(e.target.value)}
                    style={{
                      width: "150px",
                      maxWidth: "100%",
                      fontSize: "14px",
                      height: "32px",
                      padding: "4px 10px",
                    }}
                  >
                    <option value="name">Sort: Name (A–Z)</option>
                    <option value="status">Sort: Status</option>
                  </Form.Select>
                </Col>
                <Col xs="auto">
                  <Badge bg="secondary">Total: {filteredData.length}</Badge>
                </Col>
              </Row>

              <Table striped bordered hover responsive>
                <thead>
                  <tr>
                    {[
                      "Sr.No",
                      "Name",
                      "Code",
                      "Yearly",
                      "For Service",
                      "Paid Leave",
                      "Status",
                      "Action",
                    ].map((h) => (
                      <th
                        key={h}
                        style={{ backgroundColor: "#2E5CB8", color: "white" }}
                      >
                        {h}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {isLoading ? (
                    <tr>
                      <td colSpan="8" className="text-center py-4">
                        <div className="text-muted">
                          <i className="bi bi-hourglass-split fs-3 d-block mb-2"></i>
                          Loading...
                        </div>
                      </td>
                    </tr>
                  ) : paginated.length > 0 ? (
                    paginated.map((item, i) => (
                      <tr key={item.id}>
                        <td>{(currentPage - 1) * itemsPerPage + i + 1}</td>
                        <td>{item.leaveName}</td>
                        <td>{item.leaveCode || "-"}</td>
                        <td>{item.yearly ? "Yes" : "No"}</td>
                        <td>{item.forService ? "Yes" : "No"}</td>
                        <td>{item.paidLeave ? "Yes" : "No"}</td>
                        <td>{item.status ? "Active" : "Inactive"}</td>
                        <td>
                          <Button
                            className="btn btn-secondary"
                            onClick={() => handleEdit(item)}
                            type="button"
                            style={{ padding: "3px 8px", fontSize: "12px" }}
                          >
                            <i className="bi bi-pencil-fill me-1" /> Edit
                          </Button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="8" className="text-center py-4">
                        <div className="text-muted">
                          <i className="bi bi-inbox fs-3 d-block mb-2"></i>
                          No leave types found
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>

              {totalPages > 1 && (
                <div className="d-flex justify-content-end">
                  <Pagination className="flex-wrap">
                    <Pagination.Prev
                      onClick={() => setCurrentPage(currentPage - 1)}
                      disabled={currentPage === 1}
                    />
                    {[...Array(totalPages).keys()].map((n) => (
                      <Pagination.Item
                        key={n}
                        active={n + 1 === currentPage}
                        onClick={() => setCurrentPage(n + 1)}
                      >
                        {n + 1}
                      </Pagination.Item>
                    ))}
                    <Pagination.Next
                      onClick={() => setCurrentPage(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    />
                  </Pagination>
                </div>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <ToastContainer />
    </Container>
  );
};

export default LeaveType;
